<template>
  <div>
    <MainNavBarWapV2 :object-data="infoHeader" />
    <!-- desktop >768px md -->
    <div class="desktop ">
      <el-row style="margin: auto;" class="full-width container top-spacing">
        <el-col :xs="24" :sm="13" :md="13" :lg="13">
          <div class="banner-facility">
            <img
              class="full-width banner-facility"
              src="https://web-api.vcallid.com/static/uploads/e97e2bba-bc46-45c2-b085-1e7fa8894911.png"
              alt=""
            />
          </div>
          <div class="contact-container ">
            <h3 class="facility-name">Tam Đảo Golf</h3>
            <div class="detail-contact-container">
              <img :src="icons.AddressBrownIcon" alt="" />
              <p class="text-contact">Vĩnh Phúc, Hà Nội</p>
            </div>
            <div class="detail-contact-container">
              <img :src="icons.PhoneIcon" alt="" />
              <p class="text-contact">0243 567 890</p>
            </div>
            <div class="detail-contact-container">
              <img :src="icons.SocialIcon" alt="" />
              <p class="text-contact">www.tamdaogolf.com</p>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="10" :md="10" :lg="10">
          <div class="describe-container px-15">
            <h3 class="facility-name m-0">Mô tả</h3>
            <p
              :class="{ 'hide-content': !isShowContent }"
              class="describe-facility c-black-text "
            >
              Đầu mùa giải năm ngoái links courses, Maidstone is also one of the
              country’s earliest golf residential communities. Legend has it
              that Bobby Jones felt that Maidstone’s final three holes made it
              one of the great match-play courses in America. If so, that’s
              because the 17th has one of the tightest green sites in America,
              the green sitting just in front of a major street intersection,
              with roads right and left less
            </p>
            <p @click="onShowContent" class="see-more c-inherit-text">
              {{ more }}
            </p>
          </div>
          <div class="divider-view"></div>
          <div class="policy-facility px-15 mb-20">
            <h3 class="facility-name">Chính sách của sân</h3>
            <div class="flex">
              <div class="flex">
                <img class="mr-10" :src="icons.NotedIcon" alt="" />
                <p class="m-0 c-black-text">Một số yêu cầu của sân</p>
              </div>
              <img :src="icons.ArrowRightIcon" alt="" />
            </div>
          </div>
          <div class="px-15">
            <button
              @click="$router.push('/wap/booking')"
              class="btn-submit bg-btn-main c-white-text full-width"
            >
              Đặt sân nhanh
            </button>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- end of desktop -->

    <!-- mobile <768px xs-->
    <div class="mobile">
      <div style="padding-top: 60px;" class="full-width px-15 content">
        <h2 class="c-rather-text c-tiny m-0">ĐIỀU 1. NGUYÊN TẮC CHUNG 1.</h2>
        <p class="m-0 c-tiny c-medium-text">
          1. Trước khi đăng ký sử dụng dịch vụ HIO trên nền tảng Ứng dụng
          vHandicap, Khách hàng xác nhận đã đọc, hiểu và đồng ý với tất cả các
          Điều khoản trong Thỏa Thuận Cung Cấp Và Sử Dụng Dịch Vụ HIO này (sau
          đây gọi tắt là “Thỏa thuận”) thông qua việc đồng ý đăng ký sử dụng
          dịch vụ HIO, Khách hàng chấp nhận không có bất kỳ giới hạn nào về
          và/hoặc liên quan tới tất cả các điều khoản và điều kiện dưới đây, kể
          từ thời điểm đăng ký sử dụng dịch vụ.
        </p>
        <p class="m-0 c-tiny c-medium-text">
          2. Khi tham gia dịch vụ HIO được cung cấp bởi Công ty Cổ phần Dịch Vụ
          Thể Thao Golf Việt Nam (sau đây gọi tắt là “Chúng tôi” hoặc “VGS
          SPORT”) trên nền tảng ứng dụng vHandicap, Khách hàng cam kết có đủ
          tuổi theo luật định để xác lập thỏa thuận có tính ràng buộc, và không
          phải là người bị ngăn cấm tiếp nhận Dịch vụ theo pháp luật Việt Nam,
          hoặc đã có sự chấp thuận trước của cha mẹ hoặc người giám hộ hợp pháp
          để sử dụng Dịch vụ theo quy định và phù hợp với thỏa thuận này.
        </p>
        <p class="m-0 c-tiny c-medium-text">
          3. Chúng tôi có thể chỉnh sửa, cập nhật Thỏa thuận này bất cứ lúc nào
          mà không cần báo trước. Việc chỉnh sửa này sẽ có hiệu lực ngay khi
          được cập nhật trên Ứng dụng vHandicap. Khách hàng cần thường xuyên
          kiểm tra các thay đổi này, và việc khách hàng tiếp tục tham gia dịch
          vụ này đồng nghĩa với việc đồng ý với các nội dung đã thay đổi đó.
        </p>
        <h2 class="c-rather-text c-tiny m-0 mt-10">
          ĐIỀU 2: GIẢI THÍCH DỊCH VỤ HIO.
        </h2>
        <p class="m-0 c-tiny c-medium-text">
          1. Dịch vụ HIO là Dịch vụ Giải đấu trong môn thể thao Golf, mà ở đó
          Giải thưởng “Hole-in-One” sẽ được trao cho Người chơi thực hiện thành
          công đánh bóng xuống lỗ gôn quy định chỉ bằng một (01) cú đánh từ điểm
          phát bóng (đối với các hố Par3 trên sân gôn trong 1 vòng thi đấu 18 hố
          gôn) với các giá trị Giải thưởng tùy thuộc vào Dịch vụ HIO mà khách
          hàng lựa chọn sử dụng.
        </p>
        <p class="m-0 c-tiny c-medium-text">
          2. Giải đấu HIO là Giải đấu Golf được tổ chức bởi Công ty Cổ phần Dịch
          Vụ Thể Thao Golf Việt Nam mà trong Giải đấu này, khách hàng đã lựa
          chọn, sử dụng Dịch vụ HIO do Công ty Cổ phần Dịch Vụ Thể Thao Golf
          Việt Nam cung cấp thông qua ứng dụng vHandicap. Bằng việc đăng ký sử
          dụng Dịch vụ, khách hàng đồng ý rằng VGS Sport sẽ là đơn vị tổ chức
          chính thức cho Giải đấu HIO mà khách hàng tham dự.
        </p>
        <p class="m-0 c-tiny c-medium-text">
          3. Giải thưởng HIO chỉ được trao 01 lần/01 khách hàng/01 ngày thi
          đấu/01 vòng thi đấu 18 hố gôn tiêu chuẩn (Trong trường hợp Khách hàng
          đánh trúng HIO từ 02 lần trở lên trong 1 ngày thi đấu thì cũng chỉ
          được nhận 1 lần giải thưởng tương ứng với giá trị Dịch vụ HIO mà khách
          hàng đã đăng ký).
        </p>
        <p class="m-0 c-tiny c-medium-text">
          4. Trường hợp khách hàng đăng ký tham gia 2 gói dịch vụ HIO cho cùng 1
          vòng đấu 18 hố (Gói Bảo Hiểm Theo ngày và gói Hội viên theo năm) khách
          hàng có thể nhận được đồng thời 2 giải thưởng HIO tương ứng với giá
          trị giải thưởng của 2 dịch vụ đã đăng ký.
        </p>
        <h2 class="c-rather-text c-tiny m-0 mt-10">
          ĐIỀU 3. ĐIỀU KIỆN THAM GIA DỊCH VỤ HIO 1.
        </h2>
        <p class="m-0 c-tiny c-medium-text">
          1. Dịch vụ HIO chỉ được cung cấp cho những Giải đấu HIO khi: • Có tối
          thiểu 03 người cùng chơi/thi đấu tại thời điểm phát bóng • Sân Golf
          thi đấu là sân Golf 18 hố tiêu chuẩn • Vùng cỏ tại lỗ gôn được chọn sẽ
          không được thay đổi hoặc sắp xếp đặc biệt so với điều kiện tiêu chuẩn
          của các cuộc chơi thông thường cũng như được đặt tại vị trí thuận lợi
          cho việc giành Giải thưởng. • Cú đánh “Hole-in-One” (Một gậy vào lỗ
          par 3 từ điểm phát bóng) phải được thực hiện trong Giải đấu HIO bởi
          khách hàng đã đăng ký Dịch vụ. • Không được phép đánh thử trong giải
          thi đấu chính thức của Giải đấu HIO. • Mỗi người chơi chỉ được đánh
          một lần trong ngày thi đấu chính thức (Đối với dịch vụ HIO của giải
          đấu theo ngày). • Loai bóng thi đấu phải theo tiêu chuẩn và trong
          trường hợp trúng HIO thì phải được xác nhận về loại bóng trên Giấy
          chứng nhận Hole-in-one của sân golf. • Khách hàng tham gia giải đấu
          phải có mã vHandicap trên phần mềm app vHandicap của Công ty cổ phần
          dịch vụ golf Việt Nam.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import MainNavBarWapV2 from "../../../../layout/WapV2/MainNavBar.vue";
import GolfIcon from "@/assets/img/svg/golf-icon.svg";
import PhoneIcon from "@/assets/img/svg/phone-icon.svg";
import SocialIcon from "@/assets/img/svg/social-icon.svg";
import AddressBrownIcon from "@/assets/img/svg/address-brown-icon.svg";
import NotedIcon from "@/assets/img/svg/noted-icon.svg";
import ArrowRightIcon from "@/assets/img/svg/arrow-right-icon.svg";
import PIVIcon from "@/assets/img/svg/W_PIV.svg";
import HIOIcon from "@/assets/img/svg/W_HIO.svg";

import { getBackGround } from "../../../../utils/wapAuth";

export default {
  components: {
    MainNavBarWapV2
  },
  bodyClass: "insurance-certificate",
  props: {},

  created() {},
  data() {
    return {
      isShowContent: false,
      more: "Xem thêm...",
      formRequest: {},
      rules: {},
      isActive: 0,
      infoHeader: {
        title: "Điều khoản",
        isShowHomeIcon: false
      },
      address: ["Tất cả", "Miền Bắc", "Miền Trung", "Miền Nam"],
      bg: getBackGround(),

      icons: {
        GolfIcon,
        AddressBrownIcon,
        SocialIcon,
        PhoneIcon,
        NotedIcon,
        ArrowRightIcon,
        PIVIcon,
        HIOIcon
      }
    };
  },
  watch: {},
  methods: {
    onShowContent: function() {
      this.more = this.isShowContent ? "Xem thêm..." : "Rút gọn";
      this.isShowContent = !this.isShowContent;
    },
    indexMethod(index) {
      return index + 1;
    },
    handleFilter(val) {
      this.isActive = val;
    }
  }
};
</script>
<style></style>

<style scoped>
.content {
}

.px-15 {
  padding: 0 15px;
}

.divider-view {
  height: 10px !important;
  width: 100%;
  background-color: #e3e3e3;
  margin: 30px 0;
}

.top-spacing {
  padding-top: 100px;
}

.divider-view {
  height: 1px;
  width: 100%;
  margin-bottom: 10px;
  background-color: #ececec;
}

.px-20 {
  padding-left: 20px;
  padding-right: 20px;
}
.mb-10 {
  margin-bottom: 10px;
}
.mr-10 {
  margin-right: 10px;
}

.ml-10 {
  margin-left: 10px;
}
.ml-20 {
  margin-left: 20px;
}
.mt-20 {
  margin-top: 20px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mr-20 {
  margin-right: 20px;
}
.ml-4 {
  margin-left: 4px;
}
.flex-grow {
  flex-grow: 1;
}

.pt-12 {
  padding-top: 12px;
}
.pb-0 {
  margin-bottom: 0px;
}
.pb-80 {
  padding-bottom: 80px;
}
.mt-36 {
  margin-top: 36px;
}

@media screen and (min-width: 0px) and (max-width: 769px) {
}
</style>

<style lang="scss">
$divider-color: #d9d9d9;

.divider-view-top {
  height: 15px;
  width: 100%;
}

.column {
  flex-direction: column;
}
.desktop {
  display: block;
}
.mobile {
  display: none;
}
.uppercase {
  text-transform: uppercase;
}
.full-width {
  width: 100%;
}

@media screen and (min-width: 0px) and (max-width: 480px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
</style>
